import useText from '../common/hooks/useText'

export const useAdaptConnectorNaming = () => {
    const text = useText()

    return (connectorName?: string | null): string => {
        switch (connectorName) {
            case 'Left socket':
                return text('lblLeftSocket')
            case 'Right socket':
                return text('lblRightSocket')
            case 'Socket':
                return text('lblSocket')
            case 'Charger':
                return text('lblCharger')
            case 'Schuko':
                return text('lblSchuko')

            default:
                return connectorName || ''
        }
    }
}
